
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaPositionDetailsBuyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Investment_BuyAndHoldPositionBuy"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"netAmount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaPositionDetailsBuyFeesFragment"},"directives":[]}]}}],"loc":{"start":0,"end":248}};
    doc.loc.source = {"body":"#import '../Fees/fragment.gql'\nfragment IdeaPositionDetailsBuyFragment on Investment_BuyAndHoldPositionBuy {\n  quantity\n  amount {\n    value\n    currency\n  }\n  netAmount {\n    value\n    currency\n  }\n  date\n  ...IdeaPositionDetailsBuyFeesFragment\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../Fees/fragment.gql').definitions));


      module.exports = doc;
    
